import { connect } from 'react-redux';
import ChannelPaywall from '@/components/ChannelPaywall';
import { maybe } from '@/utils';
import { currentSessionObjSelector, currentSessionSelector } from '@/selectors';

const mapStateToProps = state => {
  const currentSession = currentSessionObjSelector(state);
  const sessionId = currentSessionSelector(state);
  return {
    teamPlan: maybe(currentSession, 'sessionInfo', 'teamPlan'),
    sessionId,
    isAdmin: maybe(currentSession, 'sessionInfo', 'teamInfo', 'isAdmin'),
  };
};
export default connect(mapStateToProps)(ChannelPaywall);



// WEBPACK FOOTER //
// ./src/containers/ChannelPaywallContainer.js